/* Keep consent choices available on demand in this advertorial's footer.
 * Closing the initial notice never accepts, rejects or changes consent.
 */
class MellowAdvertorialCookieFooter extends HTMLElement {
  #controller;
  #documentObserver;
  #rootObserver;
  #root;
  #button;
  #fallback;
  #requested = false;
  #dialogs = new WeakSet();

  connectedCallback() {
    this.#controller = new AbortController();
    this.#button = this.querySelector('[data-cookie-settings]');
    this.#fallback = this.querySelector('[data-cookie-fallback]');
    if (!this.#button || !this.#fallback) return;
    this.#button.addEventListener('click', () => {
      const widget = this.#root?.querySelector('button.widget[aria-haspopup="dialog"]');
      this.#requested = true;
      widget?.click();
    }, { signal: this.#controller.signal });
    window.addEventListener('pageshow', () => this.#sync(), { signal: this.#controller.signal });
    this.#documentObserver = new MutationObserver(() => this.#sync());
    this.#documentObserver.observe(document.documentElement, { childList: true, subtree: true });
    this.#sync();
  }

  #sync() {
    const host = document.querySelector('pandectes-cmp[data-active-instance="true"]');
    const root = host?.shadowRoot;
    if (!root) return;
    if (this.#root !== root) {
      this.#rootObserver?.disconnect();
      this.#root = root;
      this.#rootObserver = new MutationObserver(() => this.#sync());
      this.#rootObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    }
    root.querySelectorAll('dialog.dialog').forEach(dialog => {
      if (!this.#dialogs.has(dialog)) {
        this.#dialogs.add(dialog);
        dialog.addEventListener('close', () => { this.#requested = false; }, { signal: this.#controller.signal });
      }
      if (!dialog.open) return;
      if (!this.#requested) {
        // Native close releases the browser's modal focus trap and backdrop.
        dialog.close();
        return;
      }
      if (!dialog.querySelector('[data-mellow-cookie-close]')) {
        const close = document.createElement('button');
        close.type = 'button';
        close.dataset.mellowCookieClose = '';
        close.textContent = 'Close';
        close.style.cssText = 'display:block;margin:8px auto;min-height:44px;padding:8px 16px;text-decoration:underline';
        close.addEventListener('click', () => {
          this.#requested = false;
          dialog.close();
          this.#button.focus();
        }, { signal: this.#controller.signal });
        dialog.append(close);
      }
    });
    if (!root.querySelector('[data-mellow-widget-style]')) {
      const style = document.createElement('style');
      style.dataset.mellowWidgetStyle = '';
      // Important overrides the app's widget presentation, never its consent dialog.
      style.textContent = 'button.widget[aria-haspopup="dialog"]{display:none!important}';
      root.append(style);
    }
    if (!root.querySelector('button.widget[aria-haspopup="dialog"]')) return;
    this.#button.hidden = false;
    this.#fallback.hidden = true;
    this.#documentObserver?.disconnect();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#documentObserver?.disconnect();
    this.#rootObserver?.disconnect();
  }
}

if (!customElements.get('mellow-cookie-footer')) {
  customElements.define('mellow-cookie-footer', MellowAdvertorialCookieFooter);
}
